var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.53 81.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #070909;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5 {\n        isolation: isolate;\n      }\n\n      .st0, .st1, .st3, .st4, .st5 {\n        font-family: NovaSquare, 'Nova Square';\n        font-size: 40px;\n      }\n\n      .st0, .st4 {\n        letter-spacing: -.02em;\n      }\n\n      .st1, .st3 {\n        letter-spacing: -.06em;\n      }\n\n      .st3 {\n        fill: #231f20;\n      }\n\n      .st4, .st5 {\n        fill: #a11e21;\n      }\n\n      .st5 {\n        letter-spacing: -.04em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(0 55.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(18.93 55.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "eon")), /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(82.74 55.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(97.56 55.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F")), /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(116.86 55.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(137.33 55.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "rsythe")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImg);
export default __webpack_public_path__ + "static/media/logoImg.68ae6e2f4155f12fe0efa3d761f0ea80.svg";
export { ForwardRef as ReactComponent };